/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_SotaInputs */

const en_footer_risks_sota = /** @type {(inputs: Footer_Risks_SotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State of the art`)
};

/**
* | output |
* | --- |
* | "State of the art" |
*
* @param {Footer_Risks_SotaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_sota = /** @type {((inputs?: Footer_Risks_SotaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_SotaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_sota(inputs)
});